import Link from "next/link";
import React from 'react';


export default function Footer() {
    const quickLinks = [
        { label: "About", href: "/about" },
        { label: "AR VR MR", href: "/projects/ar-vr-mr" },
        { label: "App Development", href: "/projects/app-development" },
        { label: "Web Development", href: "/projects/web-development" },
        { label: "UI / UX", href: "/projects/ui-ux-design" },
        { label: "AI Consultancy", href: "/projects/ai-consultancy" },
        { label: "Contact", href: "/contact" },
    ];

    return (
        <footer className="footer-web-test bg-[#1c1c1c] text-white pt-[128px] lg:pt-[128px]! pb-0 overflow-hidden box-border">
            <style jsx>{`
                .footer-web-test {
                   /* Force reset font family and base styles */
                   font-size: 16px !important;
                   line-height: 1.5 !important;
                }

                /* Ensure link styling doesn't get overridden */
                .footer-web-test a {
                    text-decoration: none !important;
                    color: inherit;
                }
                .footer-section-title {
                    display: flex !important;
                    align-items: center !important;
                    flex-direction: row !important;
                    gap: 8px !important;
                }
                .title-dot {
                    width: 6px !important;
                    height: 6px !important;
                    border-radius: 50% !important;
                    background-color: white !important;
                    display: block !important;
                    flex-shrink: 0 !important;
                }
            `}</style>
            <div className="px-[24px] md:px-[80px] lg:px-[160px] box-border">
                {/* Increased max-width to 1600px to match larger screens better, effectively mimicking 2xl container + breathing room */}
                <div className="w-full max-w-[1600px] mx-auto box-border">
                    <div className="grid grid-cols-1 lg:grid-cols-12 gap-[32px] lg:gap-[64px]">
                        {/* Left Column - Headline & Socials */}
                        <div className="lg:col-span-5">
                            <h4 className="text-[60px] lg:text-[80px]! font-bold! leading-[0.95]! tracking-tight! mb-[24px]! text-white!">
                                Helping<br />
                                start-ups<br />
                                scale & grow.
                            </h4>

                            <div className="mb-[40px] mt-[32px]">
                                <Link
                                    href="/contact"
                                    className="inline-flex items-center gap-[8px] px-[24px] py-[10px] border border-white/20 text-white rounded-full text-[18px]! font-medium! hover:bg-white hover:text-black transition-all duration-300 group no-underline"
                                >
                                    Get In Touch
                                    <svg
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="w-[20px] h-[20px] group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"
                                    >
                                        <path
                                            d="M3.33331 12.6667L12.6666 3.33337M12.6666 3.33337V12.4M12.6666 3.33337H3.59998"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </Link>
                            </div>


                        </div>

                        {/* Middle Column - Quick Links */}
                        <div className="lg:col-span-4">
                            <h4 className="footer-section-title mb-[24px] text-[18px]! font-medium! text-white!">
                                <span className="title-dot"></span>
                                <span>Quick links</span>
                            </h4>

                            <div className="flex flex-wrap gap-[8px]">
                                {quickLinks.map((link, i) => (
                                    <Link
                                        key={i}
                                        href={link.href}
                                        className="px-[16px] py-[8px] border border-white/20 rounded-full text-[11px]! font-medium! text-gray-300 hover:bg-white hover:text-black hover:border-white transition-all duration-300 uppercase tracking-wider no-underline"
                                    >
                                        {link.label}
                                    </Link>
                                ))}
                            </div>
                        </div>

                        {/* Right Column - Contact */}
                        <div className="lg:col-span-3">
                            <h4 className="footer-section-title mb-[20px] text-[18px]! font-medium! text-white!">
                                <span className="title-dot"></span>
                                <span>Contact</span>
                            </h4>

                            <div className="space-y-[12px] text-gray-400 text-[16px]!">
                                <a
                                    href="tel:+917907157244"
                                    target="_blank"
                                    className="block hover:text-white transition-colors no-underline text-gray-400"
                                >
                                    (91) 79071 57244
                                </a>
                                <a
                                    href="https://www.google.com/maps/"
                                    target="_blank"
                                    className="block leading-relaxed hover:text-white transition-colors no-underline text-gray-400"
                                >
                                    Level 4, Dotspace Business Centre,<br />
                                    Total Tower, Elamakara, Edappally,<br />
                                    Cochin, Kerala - 682024
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Bottom - Massive Text */}
            <div className="w-full flex justify-end mt-[96px] px-[24px] md:px-[80px] lg:px-[160px]">
                <h1 className="text-[11vw]! leading-[0.8]! font-bold! tracking-tighter! text-white! text-right mb-[10px] mr-[-70px]">
                    hello@kitebe.in
                </h1>
            </div>
        </footer>
    );
}
